import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  readonly children: ReactNode;
}

interface State {
  readonly error: Error | null;
}

/**
 * Penahan terakhir untuk render yang melempar.
 *
 * ADA KARENA aplikasi ini tidak punya satu pun sebelumnya, dan akibatnya bukan sekadar tampilan
 * jelek: satu `TypeError` di dalam satu komponen membuat React melepas SELURUH pohon, dan yang
 * dilihat pemakai adalah layar putih kosong. Tanpa satu kata pun. Terjadi 26 Agustus 2026 pada
 * manajer yang baru selesai mengisi tugas pengiriman — dari layar itu tidak mungkin tahu apakah
 * tugasnya tersimpan, apakah jaringannya putus, atau apakah aplikasinya rusak.
 *
 * Yang diperbaiki di sini BUKAN penyebabnya (bentuk data yang meleset — lihat
 * `parseTaskDocuments`), melainkan cara gagalnya. Layar putih tidak dapat dilaporkan, tidak dapat
 * ditindaklanjuti, dan tidak dapat dibedakan dari aplikasi yang mati. Pesan dapat.
 *
 * SENGAJA tidak memakai `window.location.reload()` sebagai satu-satunya jalan keluar: memuat
 * ulang pada keadaan yang sama akan melempar lagi, dan pemakai terjebak dalam lingkaran. Tombol
 * kembali ke Beranda memberi jalan ke layar yang hampir pasti masih sehat.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Konsol adalah satu-satunya tempat jejak ini tersimpan — belum ada pelaporan galat jarak
    // jauh. Dicatat utuh supaya rekaman layar pemakai masih bisa disusul pemeriksaan konsol.
    console.error('[workforce] render gagal:', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="card error" role="alert">
        <h2>Layar ini gagal ditampilkan</h2>
        <p>
          Ada bagian aplikasi yang berhenti bekerja. Pekerjaan yang sudah tersimpan tidak hilang —
          yang gagal adalah menampilkannya.
        </p>
        <p className="muted small">
          Bila ini terus terjadi, sebutkan layar apa yang sedang Anda buka dan apa yang baru saja
          Anda tekan. Keterangan teknisnya: {error.message || 'tanpa keterangan'}
        </p>
        <button
          type="button"
          className="button-primary"
          onClick={() => {
            this.setState({ error: null });
            window.location.assign('/');
          }}
        >
          Kembali ke Beranda
        </button>
      </div>
    );
  }
}
